module.exports = __webpack_public_path__ + "a8a10a3e/img/at-icon.5d6fc5d8.svg";